const data = {
  "gclientId": "695218775603-626st3466nmj5k7h7kr87gvfn6k55kn8.apps.googleusercontent.com",
  "publishtext": "Publica con nosotros. Editorial de la Universidad del Valle hecha por autores para autores.",
  "contact": "",
  "abouttext": "El programa editorial de la Universidad del Valle hecha por autores para autores.",
  "breadcrumbs": [],
  "authorletters": [{
    "letter": "A",
    "href": "/editorial/authors/a/search"
  }, {
    "letter": "B",
    "href": "/editorial/authors/b/search"
  }, {
    "letter": "C",
    "href": "/editorial/authors/c/search"
  }, {
    "letter": "D",
    "href": "/editorial/authors/d/search"
  }, {
    "letter": "E",
    "href": "/editorial/authors/e/search"
  }, {
    "letter": "F",
    "href": "/editorial/authors/f/search"
  }, {
    "letter": "G",
    "href": "/editorial/authors/g/search"
  }, {
    "letter": "H",
    "href": "/editorial/authors/h/search"
  }, {
    "letter": "I",
    "href": "/editorial/authors/i/search"
  }, {
    "letter": "J",
    "href": "/editorial/authors/j/search"
  }, {
    "letter": "K",
    "href": "/editorial/authors/k/search"
  }, {
    "letter": "L",
    "href": "/editorial/authors/l/search"
  }, {
    "letter": "M",
    "href": "/editorial/authors/m/search"
  }, {
    "letter": "N",
    "href": "/editorial/authors/n/search"
  }, {
    "letter": "O",
    "href": "/editorial/authors/o/search"
  }, {
    "letter": "P",
    "href": "/editorial/authors/p/search"
  }, {
    "letter": "Q",
    "href": "/editorial/authors/q/search"
  }, {
    "letter": "R",
    "href": "/editorial/authors/r/search"
  }, {
    "letter": "S",
    "href": "/editorial/authors/s/search"
  }, {
    "letter": "T",
    "href": "/editorial/authors/t/search"
  }, {
    "letter": "U",
    "href": "/editorial/authors/u/search"
  }, {
    "letter": "V",
    "href": "/editorial/authors/v/search"
  }, {
    "letter": "W",
    "href": "/editorial/authors/w/search"
  }, {
    "letter": "X",
    "href": "/editorial/authors/x/search"
  }, {
    "letter": "Y",
    "href": "/editorial/authors/y/search"
  }, {
    "letter": "Z",
    "href": "/editorial/authors/z/search"
  }],
  "bookletters": [{
    "letter": "A",
    "href": "/editorial/books/a/search"
  }, {
    "letter": "B",
    "href": "/editorial/books/b/search"
  }, {
    "letter": "C",
    "href": "/editorial/books/c/search"
  }, {
    "letter": "D",
    "href": "/editorial/books/d/search"
  }, {
    "letter": "E",
    "href": "/editorial/books/e/search"
  }, {
    "letter": "F",
    "href": "/editorial/books/f/search"
  }, {
    "letter": "G",
    "href": "/editorial/books/g/search"
  }, {
    "letter": "H",
    "href": "/editorial/books/h/search"
  }, {
    "letter": "I",
    "href": "/editorial/books/i/search"
  }, {
    "letter": "J",
    "href": "/editorial/books/j/search"
  }, {
    "letter": "K",
    "href": "/editorial/books/k/search"
  }, {
    "letter": "L",
    "href": "/editorial/books/l/search"
  }, {
    "letter": "M",
    "href": "/editorial/books/m/search"
  }, {
    "letter": "N",
    "href": "/editorial/books/n/search"
  }, {
    "letter": "O",
    "href": "/editorial/books/o/search"
  }, {
    "letter": "P",
    "href": "/editorial/books/p/search"
  }, {
    "letter": "Q",
    "href": "/editorial/books/q/search"
  }, {
    "letter": "R",
    "href": "/editorial/books/r/search"
  }, {
    "letter": "S",
    "href": "/editorial/books/s/search"
  }, {
    "letter": "T",
    "href": "/editorial/books/t/search"
  }, {
    "letter": "U",
    "href": "/editorial/books/u/search"
  }, {
    "letter": "V",
    "href": "/editorial/books/v/search"
  }, {
    "letter": "W",
    "href": "/editorial/books/w/search"
  }, {
    "letter": "X",
    "href": "/editorial/books/x/search"
  }, {
    "letter": "Y",
    "href": "/editorial/books/y/search"
  }, {
    "letter": "Z",
    "href": "/editorial/books/z/search"
  }],
  "headerbuttons": [
    { "text": 'Carro de compras', "sub": "", "path": '/editorial/shopping-cart', "icon": 'FaShoppingCart' },
    { "text": 'Mi cuenta', "sub": "Ingresa o Regístrate", "path": '/editorial/user-access', "icon": 'FaUserAlt', type: 'btn' }
  ],
  "collection": [{
    src: "http://localhost:8000/assets/app/first.png"
  },
  {
    src: "http://localhost:8000/assets/app/second.png"
  },
  {
    src: "http://localhost:8000/assets/app/third.png"
  },
  {
    src: "http://localhost:8000/assets/app/fourth.png"
  },
  {
    src: "http://localhost:8000/assets/app/fifth.png"
  },
  {
    src: "http://localhost:8000/assets/app/sixth.png"
  }
  ],
  "homemenu": [{
    "key": 1,
    "title": "Autores >",
    "image": "https://dummyimage.com/300x400/f2f2f2/5e5f66",
    "href": "/authors",
    "backcolor": "#c20e1a",
    "color": "white"
  }, {
    "key": 2,
    "title": "Obras >",
    "image": "https://dummyimage.com/300x400/f2f2f2/5e5f66",
    "href": "/books",
    "backcolor": "#599876",
    "color": "white"
  }, {
    "key": 3,
    "title": "¿Como publicar?",
    "image": "https://dummyimage.com/300x400/f2f2f2/5e5f66",
    "href": "/publish",
    "backcolor": "#42a8bf",
    "color": "white"
  }, {
    "key": 4,
    "title": "Contáctenos",
    "image": "https://dummyimage.com/300x400/f2f2f2/5e5f66",
    "href": "/contact",
    "backcolor": "#532888",
    "color": "white"
  }, {
    "key": 5,
    "title": "Conózcanos",
    "image": "https://dummyimage.com/300x400/f2f2f2/5e5f66",
    "href": "/about",
    "backcolor": "#3f1517",
    "color": "white"
  }],
  "homenew": {
    "title": "Feria Internacional del libro Cali",
    "short": "La Feria Internacional del Libro de Bogotá es un evento en el que se reúnen expositores de la industria del libro provenientes de todo el mundo",
    "date": "01-05-2022",
    "image": "https://revistanuve.com/wp-content/uploads/2020/08/Oficina.jpg-principal.jpg",
    "href": "/news/c1272s",
  },
  "commonmenu": [{
    "id": "5a2493c33c95a1281836eb6a",
    "title": 'Autores',
    "image": "https://dummyimage.com/200x300/C70039/fff",
    "href": "/authors"
  }, {
    "id": "5a2493c33c95a1281836eb6b",
    "title": 'Obras',
    "image": "https://dummyimage.com/200x300/FE9A2E/5e5f66",
    "href": "/books"
  }, {
    "id": "5a2493c33c95a1281836eb6c",
    "title": '¿Quiere publicar?',
    "image": "https://dummyimage.com/200x300/1e81b0/fff",
    "href": "/publish"
  }, {
    "id": "5a2493c33c95a1281836eb6d",
    "title": 'Contáctenos',
    "image": "https://dummyimage.com/200x300/abdbe3/5e5f66",
    "href": "/contact"
  }, {
    "id": "5a2493c33c95a1281836eb6e",
    "title": 'Conozcanos',
    "image": "https://dummyimage.com/200x300/873e23/fff",
    "href": "/about"
  }],
  "authors": [{
    "id": "5f92cbf10cf217478ba93561",
    "photo": "https://asocolderma.org.co/sites/default/files/styles/medium/public/dr._cesar_ivan_varela_h_._1.jpg",
    "first_name": "César Iván",
    "last_name": "Varela Hernández",
    "email": "cesaringprueaba@correou.edu.co",
    "university": "Universidad X",
    "hometown": "Cali",
    "cvlac": "http://cvlac.com/cesaring",
    "scholar": "http://schla.com/cesaring",
    "orcid": "http://orrcid.com/cesaring",
    "twitter": "http://lkd.com/cesaring",
    "linkedin": "http://lkd.com/cesaring",
    "facebook": "http://lkd.com/cesaring",
  }, {
    "id": "5f92cbf128asu217478ba9356a",
    "photo": "https://asocolderma.org.co/sites/default/files/styles/medium/public/dr._cesar_ivan_varela_h_._1.jpg",
    "first_name": "César Iván",
    "last_name": "Varela Hernández",
    "email": "cesaringprueaba@correou.edu.co",
    "university": "Universidad X",
    "hometown": "Cali",
    "cvlac": "http://cvlac.com/cesaring",
    "scholar": "http://schla.com/cesaring",
    "orcid": "http://orrcid.com/cesaring",
    "twitter": "http://lkd.com/cesaring",
    "linkedin": "http://lkd.com/cesaring",
    "facebook": "http://lkd.com/cesaring",
  }],
  "books": [{
    "id": "2726626152ddhhs",
    "thumbnail": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "portrait": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "title": "Natanael Díaz, Un poeta en los laberintos de la política",
    "short": "Es una biografía intelectual y política sobre el líder caucano Natanael Díaz",
    "author": "Luis Carlos Castillo",
    "authorId": "5f92cbf128asu2174",
    "isbn": "9786287523715",
    "bookPrice": "COP $100.000"
  }, {
    "id": "78162sas672",
    "thumbnail": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "portrait": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "title": "The book of art",
    "short": "Todos los fans de FRIENDS recurdan este libro",
    "author": "Regina Phalange",
    "authorId": "882727sshhsh1781",
    "isbn": "9786287523715",
    "bookPrice": "COP $50.000"
  }, {
    "id": "78162sas672dsads",
    "thumbnail": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "portrait": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "title": "Cali salsa forever",
    "short": "crónica, fácil de leer, que se sustenta como la salsa llegó a Cali y se quedó para siempre.",
    "author": "Rafael Quintero",
    "authorId": "83727",
    "isbn": "9786287523715",
    "bookPrice": "COP $74.000"
  }, {
    "id": "8883273662ds122",
    "thumbnail": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "portrait": "https://dummyimage.com/200x300/f2f2f2/5e5f66",
    "title": "El Carnaval de Negros y Blancos de San Juan de Pasto",
    "short": "crónica, fácil de leer, que se sustenta como la salsa llegó a Cali y se quedó para siempre.",
    "author": "Javier Mojica Madera",
    "authorId": "92828xsa21",
    "isbn": "9786287523715",
    "bookPrice": "COP $140.000"
  }]
};
export default data;